import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { UserServices } from "../../../core/services/UserServices";
import {
  httpStatusArr,
  messageTypeArr,
} from "../../../core/config/AppConstants";

export function Logout() {
  const navigate = useNavigate();
  const handleSignOut = async () => {
    try {
      const res = await UserServices.userLogout();
      if (res && res.status === httpStatusArr.ok) {
        UtilityServices.clearAllBrowserStorage();
        navigate("/login");
        UtilityServices.clearToaster();
      }
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  };
  useEffect(() => {
    handleSignOut();
    UtilityServices.showToaster({
      message: "Signing out ...",
      type: "info",
    });
  }, []);
  return <></>;
}
